// extracted by mini-css-extract-plugin
export default {"container":"GoBackHeader_container__+Yr0f","arrow":"GoBackHeader_arrow__uLEoJ","button":"GoBackHeader_button__2iA5n","goBackText":"GoBackHeader_goBackText__Yaz30"};